<script>

    export let level;
    export let issueName;
    export let content;
    export let category;
    export let topic;

    // console.log('simple issues', level, issueName);
</script>


<div class="icard {level} {category} simple">
  <div class="header">
    <p class="label">{issueName}</p>
    {#if topic}
      <h4>{topic}</h4>
    {/if}
  </div>
  {@html content}
</div>